/**
 * Régions viticoles françaises dessinées en vecteur (superposition de la vraie carte).
 * Polygones simplifiés (approximatifs) + couleur et libellé par région. Utilisés par WineMap
 * pour un rendu net et zoomable, sans image raster. Coordonnées en [lat, lng].
 */
export const WINE_REGIONS = [
  { name: 'Champagne', color: '#b98a2e', label: [49.0, 4.1],
    coords: [[49.35, 3.7], [49.3, 4.5], [48.7, 4.5], [48.6, 3.7]] },
  { name: 'Alsace', color: '#5a8a3a', label: [48.3, 7.4],
    coords: [[48.95, 7.2], [48.9, 7.8], [47.75, 7.5], [47.85, 7.05]] },
  { name: 'Vallée de la Loire', color: '#3f8aa0', label: [47.3, 0.5],
    coords: [[47.55, -1.8], [47.55, 0.9], [47.45, 2.9], [47.05, 2.8], [47.15, 0.8], [47.15, -1.8]] },
  { name: 'Bourgogne', color: '#9c4a2a', label: [47.2, 4.65],
    coords: [[47.9, 4.3], [47.85, 5.0], [46.5, 4.9], [46.65, 4.3]] },
  { name: 'Beaujolais', color: '#7a4fa0', label: [46.05, 4.68],
    coords: [[46.3, 4.5], [46.25, 4.85], [45.85, 4.85], [45.9, 4.5]] },
  { name: 'Jura · Savoie', color: '#3f8a6e', label: [46.2, 5.95],
    coords: [[47.2, 5.5], [47.1, 6.0], [45.4, 6.5], [45.4, 5.9], [46.4, 5.6]] },
  { name: 'Vallée du Rhône', color: '#8a2e2e', label: [44.5, 4.85],
    coords: [[45.15, 4.6], [45.1, 5.15], [44.0, 5.2], [43.95, 4.6]] },
  { name: 'Provence', color: '#d0863a', label: [43.5, 6.0],
    coords: [[43.9, 5.1], [43.9, 6.9], [43.0, 6.6], [43.1, 5.3]] },
  { name: 'Languedoc-Roussillon', color: '#a0306a', label: [43.1, 2.9],
    coords: [[43.9, 2.7], [43.55, 4.2], [42.55, 3.1], [42.55, 2.0], [43.35, 1.95]] },
  { name: 'Sud-Ouest', color: '#6d3b6e', label: [43.85, 0.5],
    coords: [[44.6, -0.2], [44.4, 1.7], [43.3, 1.5], [42.9, -0.5], [43.5, -0.9], [44.2, -0.3]] },
  { name: 'Bordeaux', color: '#7b2233', label: [45.0, -0.6],
    coords: [[45.5, -1.1], [45.55, -0.2], [45.0, 0.15], [44.5, 0.0], [44.55, -1.2]] },
  { name: 'Corse', color: '#8a5a2a', label: [42.1, 9.05],
    coords: [[43.0, 9.15], [42.6, 9.55], [41.4, 9.35], [41.55, 8.65], [42.6, 8.6]] },
];
